export default __webpack_public_path__ + "static/media/Hank Johnson.81992ee1.jpg";